module.exports = __webpack_public_path__ + "static/course-details-interviews.e49f6f48.png";